import React, { useContext } from "react";
import * as GrIcons from "react-icons/gr";
import { useNavigate } from "react-router-dom";

const ConfirmModal = ({
  title,
  body,
  name,
  action,
  setModal,
  redirect,
  btnName,
  btnColor,
}) => {
  const navigate = useNavigate();
  return (
    <div id="confirmModal" className="modal">
      <div className="confirm-modal-content modal-content">
        <div className="top-bar">
          <GrIcons.GrFormClose
            className="close-icon"
            onClick={() => setModal(name, false)}
          />
          <h2>{title}</h2>
        </div>
        <div className="modal-body">{body}</div>
        <div className="bottom-bar">
          <div className="btns">
            <div
              onClick={() => {
                action();
                setModal(name, false);
                if (redirect !== "false") {
                  navigate(redirect);
                }
              }}
              className={`btn btn-${btnColor}`}
            >
              {btnName}
            </div>
            <div
              className="btn btn-l4l-dark"
              onClick={() => setModal(name, false)}
            >
              Close
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
